// @flow
const EngineType: PKEngineTypes = {
  HTML5: 'html5',
  FLASH: 'flash',
  SILVERLIGHT: 'silverlight',
  CAST: 'cast'
};

export {EngineType};



// WEBPACK FOOTER //
// ./engines/engine-type.js


// WEBPACK FOOTER //
// core/engines/engine-type.js